import api from '@http/api';

export interface IApproveSolicitacao {
  id_solicitacao: number[];
}

class ComponentModalRecusaServices {
  public async RecusarDoacoes(doacaoIds: number[], observacao: string) {
    return await api
      .post('/api/Doacao/RecusarDoacoes', { doacaoIds, observacao })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }
}

export default ComponentModalRecusaServices;
